import { Handshake, TrendingUp, DollarSign, Briefcase, Target, Receipt, ShoppingCart, BarChart3, PieChart, Wallet, Package, Truck, BadgePercent, Store, CreditCard, LineChart } from "lucide-react";

const ICONS = [Handshake, TrendingUp, DollarSign, Briefcase, Target, Receipt, ShoppingCart, BarChart3, PieChart, Wallet, Package, Truck, BadgePercent, Store, CreditCard, LineChart];

export const SalesBackground = ({ dark = false }) => (
  <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(#CBD5E1_1px,transparent_1px)] [background-size:26px_26px] opacity-50" />
    <div className="absolute inset-0 grid grid-cols-6 md:grid-cols-8 gap-16 p-10" style={{ transform: "rotate(-8deg) scale(1.2)" }}>
      {Array.from({ length: 64 }).map((_, i) => {
        const Icon = ICONS[(i * 7) % ICONS.length];
        return (
          <Icon
            key={i}
            strokeWidth={1.3}
            className={dark ? "text-white" : "text-[#1E3A8A]"}
            style={{ width: 34 + ((i * 13) % 22), height: 34 + ((i * 13) % 22), opacity: dark ? 0.07 : 0.055, marginLeft: (i * 17) % 40 }}
          />
        );
      })}
    </div>
  </div>
);
